import * as React from "react";
import { Container, Grid, Paper } from "@material-ui/core";
import { useState } from "react";
import FailOnFitTrend from "./FailOnFitTrend";
import FailOnFitFilter from "./FailOnFitFilter";
import FailOnFitList from "./FailOnFitList";
import FailOnFitRateSource from "./FailOnFitRateSource";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";

const FailOnFit = props => {
  useVerifyPermission("customroutes", "failonfit.read");
  const { user } = useAuth();

  const now = new Date();
  const [filterParams, setFilterParams] = useState({
    ownerCode: user?.isCustomer ? [user?.ownerCode] : [],
    startDate: new Date(new Date().setMonth(now.getMonth() - 1)),
    endDate: now,
  });

  const CreateFilter = filterParams => {
    var filter = {
      createdDate__gte: filterParams.startDate,
      createdDate__lte: filterParams.endDate,
    };

    if (!user?.isCustomer && filterParams?.ownerCode?.length > 0) {
      let ownerCodeFilter =
        filterParams?.ownerCode?.length === 1
          ? { ownerCode__eq: filterParams.ownerCode?.[0] }
          : { ownerCode__in: filterParams.ownerCode };

      filter = Object.assign(ownerCodeFilter, filter);
    }
    if (filterParams?.fleetType) {
      filter = { ...filter, ...{ fleetType__eq: filterParams?.fleetType } };
    }
    if (filterParams?.acType) {
      filter = { ...filter, ...{ acType__eq: filterParams?.acType } };
    }

    return filter;
  };

  return (
    <>
      <FailOnFitFilter filterParams={filterParams} setFilterParams={setFilterParams} />
      <br />
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <FailOnFitTrend filterParams={CreateFilter(filterParams)} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <FailOnFitRateSource filterParams={CreateFilter(filterParams)} />
        </Paper>
      </Container>
      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <FailOnFitList basePath="reliabilityfailonfits" filterParams={CreateFilter(filterParams)} {...props} />
        </Paper>
      </Container>
    </>
  );
};

export default FailOnFit;
